<section>
  <div class="container py-5">
    <div class="row py-5">
      <div class="col-md-6 d-flex align-items-center">
        <div>
          <p class="m-0 fw-bolder">{{ 'errorPage.code500' | translate }}</p>
          <h1 class="m-0 py-3 fw-bold">{{'errorPage.serverError'|translate}}</h1>
          <p class="m-0 pb-4">{{'errorPage.serverErrorMessage'|translate}}</p>
          <div class="text-center">
            <a routerLink="/home" class="btn px-3 py-2 my-1 mx-2 text-white">{{'errorPage.home'|translate}}</a>
            <a (click)="goBack()" class="btn px-3 py-2 my-1 mx-2 border"><i class="fa-solid fa-arrow-left" [ngClass]="{'ms-1': isRtl, 'me-1': !isRtl}"></i> {{'errorPage.back'|translate}}</a>
          </div>
        </div>
      </div>
      <div class="col-md-6 pt-5 pt-md-0 d-flex align-items-center">
        <div>
          <img class="w-100" src="assets/imgs/Error500.png" alt="Error">
        </div>
      </div>
    </div>
  </div>
</section>
